module.exports = __webpack_public_path__ + "img/Icon_Pencil.d3d82ac1.svg";